import { isIOS, isAndroid, isDesktop, isMobile } from 'react-device-detect';
const isWebview = require('is-ua-webview');

export const getDeviceTypeString = () => {
  if (isDesktop) return 'DESKTOP_WEB';
  if (isMobile && isAndroid && isWebview(navigator.userAgent)) return 'ANDROID_APP';
  if (isMobile && isIOS && isWebview(navigator.userAgent)) return 'IOS_APP';
  if (isMobile) return 'MOBILE_WEB';
  return '';
};
